//chapter1
export default {
    id : 1,//chapter number
    title : '01. 몰드 공정(Molding) (1)',//chapter name
    slides : [
        {
            title : '역량 체크리스트',
            type : 'pre-test',
            checkList : [
                {
                    page : 1,
                    body : [
                        '<strong>1.</strong> 나는 몰딩공정을 진행할 때 봉지재의 가열 조건에 대해 설명할 수 있다.',
                        '<strong>2.</strong> 나는 몰딩 공정의 의미와 공정 순서를 설명할 수 있다.',
                        '<strong>3.</strong> 나는 와이어 본딩 형태 패키지와 플립칩 패키지의 구조 차이를 알고 공정 순서를 설명할 수 있다.',
                        '<strong>4.</strong> 나는 트랜스퍼 몰딩과 컴프레션 몰딩 방법의 차이를 알고 이를 설명할 수 있다.',
                        '<strong>5.</strong> 나는 몰딩 공정에서 사용되는 봉지재의 종류에 대해 이해하고 설명할 수 있다.',
                        '<strong>6.</strong> 나는 몰딩 공정에서 사용되는 봉지재를 구성하는 물질의 특성과 역할에 대해 이해하고 설명할 수 있다.',
                        '<strong>7.</strong> 나는 몰딩 후에 진행되는 마킹 공정에 대해 이해하고 설명할 수 있다.',
                        '<strong>8.</strong> 나는 마킹 공정에서 발생하는 대표적인 불량형태를 설명하고 이에 대한 대응방안을 제시할 수 있다.',
                        '<strong>9.</strong> 나는 리드프레임을 사용하는 패키지의 트림과 포밍 공정의 구체적인 의미를 이해할 수 있다.',
                        '<strong>10.</strong> 나는 솔더 볼 접합의 공정 순서를 알고 있으며, 충분히 이해하고 있다.',
                    ]
                },
                {
                    page : 2,
                    body : [
                        '<strong>11.</strong> 나는 솔더 볼 접합 공정에서 사용되는 솔더볼의 종류와 특성에 대해 이해하고 설명할 수 있다.',
                        '<strong>12.</strong> 나는 솔더 볼 접합의 공정 순서를 알고 있으며, 충분히 이해하고 있다.',
                        '<strong>13.</strong> 나는 솔더 볼 접합에 사용되는 장비의 종류와 역할에 대해 이해하고 설명할 수 있다.',
                        '<strong>14.</strong> 나는 반도체 패키지의 쏘잉과 쏘팅 공정에 대하여 알고 있으며, 공정 진행 시 필요한 툴에 대해 설명할 수 있다.',
                        '<strong>15.</strong> 나는 웨이퍼 쏘잉 공정과 패키지 쏘잉 공정의 차이를 알고 설명할 수 있다.',
                        '<strong>16.</strong> 나는 패키지 쏘잉을 진행하는 패키지와 트림과 포밍을 통해 개별화하는 패키지의 종류를 구분하고 설명할 수 있다.',
                        '<strong>17.</strong> 나는 반도체 패키지의 쏘잉과 쏘팅 공정에 대하여 알고 있으며, 공정 진행 시 필요한 툴에 대해 설명할 수 있다.',
                        '<strong>18.</strong> 나는 PCB를 사용하는 패키지와 리드프레임을 사용하는 패키지의 공정 차이를 구분하고 설명할 수 있다.',
                        '<strong>19.</strong> 나는 플립칩 패키지와 웨이퍼 레벨 패키지의 공정 순서 차이를 이해하고 설명할 수 있다.',
                        '<strong>20.</strong> 나는 반도체 패키지의 형태나 종류별 공정의 차이를 이해하고 설명할 수 있다.',
                    ]
                },
            ],
            result : {
                level1 : {
                    body : '<li>반도체 패키징 기술의 개요</li><li>반도체 패키징 기술의 정의 및 기능</li><li>반도체 패키징 기술의 발전</li><li>CSP 기술 정의 및 장단점</li>',
                    title : "초급",
                    file : "./files/01.zip",
                },
                level2 : {
                    body : '<li>플립칩</li><li>Interconnection</li><li>솔더 범프</li><li>전도 필름</li><li>UBM</li><li>Sn-Ag계</li><li>Wafer Level CSP</li>',
                    title : "중급",
                    file : "./files/02.zip",
                },
                level3 : {
                    body : '<li>MCP(Multi Chip Package)</li><li>Flip Chip 기판의 형상 및 명칭</li><li>MCP/SIP package 상용화 기술</li><li>미세회로 패턴 구현 기술</li><li>Fan-out WLP의 기술적 특징</li><li>Laser via hole 형성 기술 개발</li><li>3D PKG 구현 기술 개발</li>',
                    title : "고급",
                    file : "./files/03.zip",
                },
            },
            bgm : "checkbgm.mp3",
            // quizMask : "../assets/images/bono_quiz_mask.jpg",//quiz mask
        },
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/01/videos/a01.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '몰딩공정의 의의',
                '몰딩 공정의 종류',
            ],
            body2 : [
                '몰딩공정의 의의에 대해 설명할 수 있다.',
                '몰딩 공정의 종류에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/01/videos/01.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '패키지 종류에 따라 다양한 몰딩 방법이 사용된다.',//html available
                    answer : "1",
                    explain : '패키지 종류에 따라 다양한 몰딩 방법이 사용된다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : 'PCB 형태 패키지는 몰딩 전에 플라즈마 크리닝 공정이 필요하다.',//html available
                    answer : "1",
                    explain : 'PCB 형태 패키지는 PCB와 에폭시 수지와의 접착력을 증대시키기 위해 플라즈마 크리닝 공정이 필요하다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>몰딩공정의 의의 : 몰딩공정은 와이어 본딩이 완료된 반도체 제품을 외부환경으로부터 보호하기 위해 에폭시 몰딩 컴파운드를 이용해서 감싸주는 공정<br>
                        - 반도체 소자를 열경화성 수지인 EMC(Epoxy Molding Compound)로 성형하는 공정<br>
                        - 고체상태의 EMC를 175℃ 상태에서 Gel 상태로 변환시킨 후 성형<br>
                        - 열 및 습기 등의 환경으로부터 제품을 보호하고 Package의 외관 형성<br>
                        - Wire Bonding이 끝난 Die를 Air 및 외부의 부식, 전기적인 열화로부터 보호<br>
                        - Chip에서 발생하는 열의 발산 역할</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>몰딩 공정의 종류<br>
                        1) 패키지 종류에 따라 : 리드프레임 형태 패키지 몰딩, PCB 형태 패키지 몰딩, 웨이퍼레벨 패키지 몰딩<br>
                        2) 패키지 발전 과정에 따라 : 1세대 패키지, 2세대 패키지, 3세대 패키지</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/01/videos/a01.mp4',
        },
    ]
}